var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleMinus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icomoon-ignore"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 0c-282.506 0-512 229.494-512 512s229.494 512 512 512c282.506 0 512-229.494 512-512s-229.494-512-512-512zM512 44.522c258.442 0 467.476 209.033 467.476 467.478 0 258.442-209.034 467.476-467.476 467.476-258.445 0-467.478-209.034-467.478-467.476 0-258.445 209.033-467.478 467.478-467.478zM244.87 534.262v-44.522h534.261v44.522h-534.261z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleMinus);
export default __webpack_public_path__ + "static/media/circle-minus.fabd6a39b079c2aadd46a93c980c26b9.svg";
export { ForwardRef as ReactComponent };